module.exports = __webpack_public_path__ + "static/media/mehmood_deshmukh.ecb5dc8e.png";